module.exports = __webpack_public_path__ + "static/media/cnn.com_2016_10_06_us_hurricane-matthew-live-updates_index.html_plot.2c2d8a20.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_2016_10_06_us_hurricane-matthew-live-updates_index.html_plot.png
// module id = 378
// module chunks = 0